import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GetLinkRequestModel } from 'src/app/models/community';
import { ForceBaseUrl, ConfigurationService } from '../configuration/configuration.service';
import { EndpointFactory } from '../endpoint-factory.service';

@Injectable({
  providedIn: 'root'
})
export class AuntBerthaEndpoint extends EndpointFactory {

    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('community', force) + 'community';
    }

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {

        super(http, configurations, injector);
    }

    public getProgramLink( memberData: GetLinkRequestModel): Observable<string> {

        const endpointUrl = `${this.getServiceBaseUrl()}/getauntberthaurl`;

        return this.http.post<string>(endpointUrl, memberData).pipe<string>(
            catchError(error => {
                return this.handleError(error);
            })
        );
    }
}
